import { createError } from './create-error';
export const ValidationError = createError('ValidationError', 'Validation error', {
  INVALID_PAYLOAD: 'Invalid payload'
});